import aiFriendManageApi from "../../../api/aiFriendManage";

export default {
  data() {
    return {
      item: {
        type: "select",
        label: "角色",
        placeholder: "请输入角色",
        key: "roleId",
        contentWidth: "200px",
        options: [],
        props: {
          remote: true,
          remoteMethod: this.remoteMethod,
        },
      },
    };
  },
  methods: {
    async remoteMethod(text) {
      console.log(text, this.item);
      try {
        const r = await aiFriendManageApi.getAiRoleList({
          name: text,
          pageNumber: 1,
          pageSize: 10,
        });
        const data = r.data;
        this.item.options = data.list.map((val) => ({
          label: val.name,
          value: val.id,
        }));
      } catch (error) {
        console.error("搜索ai角色失败：", error);
      }
      // this.item.options = [{ label: "123", value: 123 }];
    },
  },
};